import { withDirectModifiedFields } from 'utils/pendingChanges';

export class LoanContactsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanContacts({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/contacts`);
  }

  async getLoanContactsView({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/contacts/view`),
    );
  }
}
